// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const MINER = '/miner-group';
const VALIDATOR = '/validator-group';
const PROJECTS = '/projects';
const MANAGE_FUNDS = '/manage-funds';
const ADMIN = '/admin';
const PUBLIC_RECORD = '/public-record';
const API_KEYS = '/api-keys';
// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  resetPasswordSent: path(ROOTS_AUTH, '/reset-password-sent'),
  registerSuccess: path(ROOTS_AUTH, '/register-success'),
  verifyPhoneNumber: path(ROOTS_AUTH, '/verify-phone-number'),
  emailLink: path(ROOTS_AUTH, '/email-link'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  public_record: PUBLIC_RECORD,
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    minerGroups: path(ROOTS_DASHBOARD, '/miner-groups'),
    // validatorGroups: path(ROOTS_DASHBOARD, '/validator-groups'),
    // projects: path(ROOTS_DASHBOARD, '/projects'),
    // manageFunds: path(ROOTS_DASHBOARD, '/manage-funds'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  api_keys: {
    all: path(API_KEYS, '/all'),
    createKey: path(API_KEYS, '/create-key'),
    createdKey: path(API_KEYS, '/created-key'),
  },
  minerGroups:{
    all: path(MINER, '/all'),
    create: path(MINER, '/create'),
    join: path(MINER, '/join'),
    groupCreated: path(MINER, '/groupCreated'),
    groupInfo: path(MINER, '/groupInfo'),
  },
  validatorGroups:{
    all: path(VALIDATOR, '/all'),
    create: path(VALIDATOR, '/create'),
    join: path(VALIDATOR, '/join'),
    groupCreated: path(VALIDATOR, '/groupCreated'),
    groupInfo: path(VALIDATOR, '/groupInfo'),
  },
  manageFunds:{
    balance: path(MANAGE_FUNDS, '/balance'),
  },
  projects:{
    all: path(PROJECTS, '/all'),
    create: path(PROJECTS, '/create'),
    projectCreated: path(PROJECTS, '/projectCreated'),
    projectInfo: path(PROJECTS, '/projectInfo'),
    projectIntervalUpload: path(PROJECTS, '/projectIntervalUpload'),
    validateInterval: path(PROJECTS, '/validateInterval'),
    projectPayoutSplits: path(PROJECTS, '/projectPayoutSplits'),
    projectPayoutApproval: path(PROJECTS, '/projectPayoutApproval'),
    projectApproval: path(PROJECTS, '/projectApproval'),
    createProjectDisclaimer: path(PROJECTS, '/createProjectDisclaimer'),
    // projectIntervalInfo: path(PROJECTS, '/projectIntervalInfo')
  },
  admin:{
    all: path(ADMIN, '/all'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
